import React, { useState, useEffect } from 'react';
import axios from 'axios';

const NAVY = '#1A3A5C';
const ORANGE = '#EA6F2E';

function formatDate(dateString) {
  const date = new Date(dateString);
  const now = new Date();
  const diff = now - date;
  const minutes = Math.floor(diff / 60000);
  const hours = Math.floor(diff / 3600000);
  const days = Math.floor(diff / 86400000);
  if (minutes < 1) return 'Just now';
  if (minutes < 60) return `${minutes}m ago`;
  if (hours < 24) return `${hours}h ago`;
  if (days < 7) return `${days}d ago`;
  return date.toLocaleDateString();
}

function TypeIcon({ type, size = 16 }) {
  const icons = {
    onboarding: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/><line x1="20" y1="8" x2="20" y2="14"/><line x1="23" y1="11" x2="17" y2="11"/></svg>,
    welcome_letter: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>,
    system: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>,
    message: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>,
  };
  return icons[type] || icons.message;
}

const typeColors = {
  onboarding:     { bg: '#EFF6FF', color: '#1E40AF' },
  welcome_letter: { bg: '#F0FDF4', color: '#065F46' },
  system:         { bg: '#FFF7ED', color: '#92400E' },
  message:        { bg: '#F5F3FF', color: '#5B21B6' },
};

export default function NotificationInbox({ navigateTo, onCountChange }) {
  const [notifications, setNotifications] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  useEffect(() => { fetchNotifications(); }, [filter]);

  const fetchNotifications = async () => {
    try {
      const token = localStorage.getItem('token');
      const params = filter === 'unread' ? { unread_only: 'true' } : {};
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/notifications`, {
        headers: { Authorization: `Bearer ${token}` }, params
      });
      setNotifications(res.data);
      setLoading(false);
    } catch (e) { console.error(e); setLoading(false); }
  };

  const openNotification = async (n) => {
    setSelected(n);
    if (!n.is_read) {
      try {
        const token = localStorage.getItem('token');
        await axios.post(`${process.env.REACT_APP_API_URL}/notifications/${n.id}/read`, {}, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setNotifications(prev => prev.map(x => x.id === n.id ? { ...x, is_read: true } : x));
        if (onCountChange) onCountChange();   // refresh the header badge
      } catch (e) { console.error(e); }
    }
  };

  const markAllAsRead = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.post(`${process.env.REACT_APP_API_URL}/notifications/read-all`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setNotifications(prev => prev.map(n => ({ ...n, is_read: true })));
      if (selected) setSelected(s => ({ ...s, is_read: true }));
      if (onCountChange) onCountChange();   // refresh the header badge
    } catch (e) { console.error(e); }
  };

  const unreadCount = notifications.filter(n => !n.is_read).length;

  return (
    <div style={{ display:'flex', height:'calc(100vh - 64px)', background:'#F9FAFB', overflow:'hidden' }}>
      <div style={{ width:'340px', minWidth:'340px', background:'#fff', borderRight:'1px solid #E5E7EB', display:'flex', flexDirection:'column', overflow:'hidden' }}>
        <div style={{ padding:'20px 20px 12px 20px', borderBottom:'1px solid #E5E7EB' }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'14px' }}>
            <div>
              <h2 style={{ fontSize:'15px', fontWeight:'700', color:'#111827', margin:0 }}>Inbox</h2>
              {unreadCount > 0 && <p style={{ fontSize:'11px', color:ORANGE, margin:'2px 0 0 0', fontWeight:'600' }}>{unreadCount} unread</p>}
            </div>
            {unreadCount > 0 && (
              <button onClick={markAllAsRead} style={{ fontSize:'11px', color:'#6B7280', background:'none', border:'1px solid #E5E7EB', borderRadius:'5px', padding:'4px 10px', cursor:'pointer', fontWeight:'500' }}>
                Mark all read
              </button>
            )}
          </div>
          <div style={{ display:'flex', gap:'4px', background:'#F3F4F6', borderRadius:'7px', padding:'3px' }}>
            {['all','unread'].map(f => (
              <button key={f} onClick={() => setFilter(f)} style={{ flex:1, padding:'5px', fontSize:'12px', fontWeight:filter===f?'600':'400', color:filter===f?'#fff':'#6B7280', background:filter===f?NAVY:'transparent', border:'none', borderRadius:'5px', cursor:'pointer', transition:'all 0.15s', textTransform:'capitalize' }}>
                {f === 'all' ? `All (${notifications.length})` : `Unread (${unreadCount})`}
              </button>
            ))}
          </div>
        </div>
        <div style={{ flex:1, overflowY:'auto' }}>
          {loading ? (
            <div style={{ padding:'40px', textAlign:'center', color:'#9CA3AF', fontSize:'13px' }}>Loading...</div>
          ) : notifications.length === 0 ? (
            <div style={{ padding:'60px 20px', textAlign:'center' }}>
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#D1D5DB" strokeWidth="1.5" style={{ marginBottom:'12px' }}><path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 01-3.46 0"/></svg>
              <p style={{ fontSize:'13px', color:'#9CA3AF' }}>{filter==='unread'?'No unread notifications':'No notifications yet'}</p>
            </div>
          ) : notifications.map(n => {
            const tc = typeColors[n.type] || typeColors.message;
            const isActive = selected?.id === n.id;
            return (
              <div key={n.id} onClick={() => openNotification(n)}
                style={{ padding:'14px 16px', borderBottom:'1px solid #F3F4F6', cursor:'pointer', background:isActive?'#F0F4FF':n.is_read?'#fff':'#FAFBFF', borderLeft:isActive?`3px solid ${NAVY}`:n.is_read?'3px solid transparent':`3px solid ${ORANGE}`, transition:'background 0.1s' }}
                onMouseEnter={e => { if (!isActive) e.currentTarget.style.background='#F9FAFB'; }}
                onMouseLeave={e => { e.currentTarget.style.background=isActive?'#F0F4FF':n.is_read?'#fff':'#FAFBFF'; }}>
                <div style={{ display:'flex', gap:'10px', alignItems:'flex-start' }}>
                  <div style={{ width:'32px', height:'32px', borderRadius:'8px', background:tc.bg, color:tc.color, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, marginTop:'1px' }}>
                    <TypeIcon type={n.type} size={15}/>
                  </div>
                  <div style={{ flex:1, minWidth:0 }}>
                    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'3px' }}>
                      <span style={{ fontSize:'13px', fontWeight:n.is_read?'500':'700', color:'#111827', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis', maxWidth:'180px' }}>{n.subject}</span>
                      <span style={{ fontSize:'10px', color:'#9CA3AF', flexShrink:0, marginLeft:'6px' }}>{formatDate(n.created_at)}</span>
                    </div>
                    {n.sender_first_name && <div style={{ fontSize:'11px', color:'#6B7280', marginBottom:'2px' }}>From: {n.sender_first_name} {n.sender_last_name}</div>}
                    <p style={{ fontSize:'12px', color:'#6B7280', margin:0, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{n.message}</p>
                  </div>
                  {!n.is_read && <div style={{ width:'7px', height:'7px', borderRadius:'50%', background:ORANGE, flexShrink:0, marginTop:'6px' }}/>}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div style={{ flex:1, display:'flex', flexDirection:'column', overflow:'hidden' }}>
        {!selected ? (
          <div style={{ flex:1, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center' }}>
            <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="#D1D5DB" strokeWidth="1" style={{ marginBottom:'16px' }}><path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>
            <p style={{ fontSize:'14px', fontWeight:'500', color:'#6B7280', marginBottom:'4px' }}>Select a notification</p>
            <p style={{ fontSize:'12px', color:'#9CA3AF' }}>Click any message on the left to read it</p>
          </div>
        ) : (
          <div style={{ flex:1, overflowY:'auto', padding:'36px 48px' }}>
            <div style={{ marginBottom:'24px', paddingBottom:'20px', borderBottom:'1px solid #E5E7EB' }}>
              <div style={{ display:'flex', alignItems:'center', gap:'10px', marginBottom:'12px' }}>
                {(() => { const tc = typeColors[selected.type] || typeColors.message; return (
                  <div style={{ width:'36px', height:'36px', borderRadius:'8px', background:tc.bg, color:tc.color, display:'flex', alignItems:'center', justifyContent:'center' }}>
                    <TypeIcon type={selected.type} size={17}/>
                  </div>
                ); })()}
                <span style={{ fontSize:'11px', fontWeight:'600', color:'#6B7280', textTransform:'uppercase', letterSpacing:'0.06em' }}>{selected.type?.replace('_',' ') || 'Notification'}</span>
              </div>
              <h1 style={{ fontSize:'20px', fontWeight:'700', color:'#111827', margin:'0 0 14px 0' }}>{selected.subject}</h1>
              <div style={{ display:'flex', gap:'20px', fontSize:'12px', color:'#6B7280', alignItems:'center' }}>
                {selected.sender_first_name && (
                  <div style={{ display:'flex', alignItems:'center', gap:'7px' }}>
                    <div style={{ width:'26px', height:'26px', borderRadius:'50%', background:NAVY, color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'10px', fontWeight:'700' }}>
                      {selected.sender_first_name[0]}{selected.sender_last_name?.[0]}
                    </div>
                    <span><strong style={{ color:'#374151' }}>{selected.sender_first_name} {selected.sender_last_name}</strong></span>
                  </div>
                )}
                <span>{new Date(selected.created_at).toLocaleString()}</span>
              </div>
            </div>
            <div style={{ fontSize:'14px', color:'#374151', lineHeight:'1.8', whiteSpace:'pre-wrap' }}>
              {selected.message}
            </div>
            {selected.type === 'onboarding' && navigateTo && (
              <div style={{ marginTop:'24px' }}>
                <button onClick={() => navigateTo('onboarding', selected.metadata?.case_id || null)} style={{ display:'inline-flex', alignItems:'center', gap:'7px', padding:'9px 18px', background:'#1A3A5C', color:'#fff', border:'none', borderRadius:'7px', fontSize:'13px', fontWeight:'600', cursor:'pointer' }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/><line x1="20" y1="8" x2="20" y2="14"/><line x1="23" y1="11" x2="17" y2="11"/></svg>
                  View Onboarding Tasks
                </button>
              </div>
            )}
            {selected.type === 'time_off' && navigateTo && (
              <div style={{ marginTop:'24px' }}>
                <button onClick={() => navigateTo('time-off')} style={{ display:'inline-flex', alignItems:'center', gap:'7px', padding:'9px 18px', background:'var(--caam-accent)', color:'#fff', border:'none', borderRadius:'7px', fontSize:'13px', fontWeight:'600', cursor:'pointer' }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                  Review Request
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
